const PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;

export function initClarity() {
  if (!PROJECT_ID) {
    return;
  }

  // Clarity snippet — loads async, non-blocking
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", PROJECT_ID);
}

/**
 * Set a custom tag in Clarity for filtering session recordings.
 * @param {string} key - Tag name
 * @param {string} value - Tag value
 */
export function setClarityTag(key, value) {
  if (!PROJECT_ID) return;
  if (window.clarity) {
    window.clarity("set", key, value);
  }
}

/**
 * Identify user in Clarity for session association.
 * @param {string} userId - Custom user ID
 * @param {string} [sessionId] - Optional session ID
 * @param {string} [pageId] - Optional page ID
 */
export function identifyClarityUser(userId, sessionId, pageId) {
  if (!PROJECT_ID) return;
  if (window.clarity) {
    window.clarity("identify", userId, sessionId, pageId);
  }
}
